import { useState } from "react";

export const emergencyContactConstraints = {
  emergencyContactName: {
    presence: {
      allowEmpty: false,
      message: "^Please enter your emergency contact’s full name",
    },
  },
  emergencyContactTelephone: {
    presence: { allowEmpty: false },
    isValidTelephone: true,
  },
};

export const useEmergencyContactState = ({
  emergencyContactName = "",
  emergencyContactTelephone = "",
}) => {
  const initialState = {
    emergencyContactName,
    emergencyContactTelephone,
  };

  const [emergencyContactState, setEmergencyContactState] =
    useState(initialState);

  const [emergencyContactErrors, setEmergencyContactErrors] = useState({
    emergencyContactName: [],
    emergencyContactTelephone: [],
  });

  const handleEmergencyContactState = (key, val) => {
    if (val !== "") {
      setEmergencyContactErrors({
        ...emergencyContactErrors,
        [key]: [],
      });
    }
    return setEmergencyContactState({
      ...emergencyContactState,
      [key]: val,
    });
  };
  return [
    emergencyContactState,
    handleEmergencyContactState,
    emergencyContactErrors,
    setEmergencyContactErrors,
  ];
};
